@if (!isBrowser) {
    @if (!isLoggedIn) {
        <a class="main-button" [class.active]="isScrolled" [routerLink]="['/login']">
            <div class="button-label" [ngClass]="{ white: !isMobile }">
                <div class="label-content" translate>Sign Up/Login</div>
            </div>
            <div class="star">
                <div class="icon"></div>
            </div>
        </a>
    } @else {
        <div class="relative" (document:click)="closeUserMenu()">
            <button
                type="button"
                class="main-button"
                [class.active]="isScrolled"
                (click)="$event.stopPropagation(); toggleUserMenu()">
                <div class="button-label" [ngClass]="{ white: !isMobile }">
                    <div class="label-content !text-sm !md:text-base max-w-36 truncate">
                        {{ userName }}
                    </div>
                </div>
                <div class="star">
                    <div class="icon"></div>
                </div>
            </button>

            <div
                class="profile-dropdown"
                [ngClass]="{ scrolled: isScrolled || isMobile }"
                [class.open]="isUserMenuOpen"
                (click)="onDropdownClick($event)">
                <a class="profile-dropdown-text" [routerLink]="['/my-profile']">My Profile</a>
                @if (providerType === SSOProviderEnum.Email) {
                    <a class="profile-dropdown-text" [routerLink]="['/change-password']">Change Password</a>
                }
                <a class="profile-dropdown-text" [routerLink]="['/my-order']">My Order</a>
                <div class="w-full h-px bg-gray-300"></div>
                <button type="button" class="profile-dropdown-text logout" (click)="logOut()">Log Out</button>
            </div>
        </div>
    }
}
